// Primary CTA surface for the Meta ads campaign.
// Centralized here so we can swap the Calendly URL in one place.
export const CALENDLY_EVENT_PATH = 'https://calendly.com/statbox/30min'

export function calendlySchedulingUrl(
  extra?: Record<string, string | undefined>,
) {
  const url = new URL(CALENDLY_EVENT_PATH)
  url.searchParams.set('hide_event_type_details', '1')
  url.searchParams.set('hide_gdpr_banner', '1')
  if (extra) {
    for (const [key, value] of Object.entries(extra)) {
      if (value) url.searchParams.set(key, value)
    }
  }
  return url.toString()
}

/** Direct link with default embed params (legacy callers). */
export const CALENDLY_URL = calendlySchedulingUrl()

/** In-app booking page — landing CTAs route here instead of off-site Calendly. */
export const BOOK_DEMO_PATH = '/book-demo'

export const VENUE_CALENDLY_URL = CALENDLY_EVENT_PATH
// TODO: replace with real Calendly event URL when set up.
// SetupVenueCompletingTransition + the venue portal Welcome page
// read this for the post-signup activation booking. Custom questions
// to add when configuring the event: a1 = venue name, a2 = primary
// sport, a3 = number of courts.

export const ACADEMY_CALENDLY_URL = CALENDLY_URL;
// TEMPORARY: points to the existing CALENDLY_URL so the inline
// widget actually renders during academy signup. Replace with the
// dedicated academy Calendly event type URL once it's set up
// (e.g. https://calendly.com/statbox/academy-intro). Custom
// questions to add when configuring: a1 = academy name.
// SignupAcademyBook reads this and appends per-user pre-fill params
// (name/email/a1) before mounting the inline widget.

export const calendlyUrl = (audience?: 'community' | 'academy' | 'venue') =>
  audience ? calendlySchedulingUrl({ audience }) : CALENDLY_URL
